'use strict';

/**
 * Formats belgian phone numbers
 */
customerZone.filter('formatPhone', ['$filter', function($filter) {

    var BE_FORMATS = [
        /^32([2349])(\d{3})(\d{2})(\d{2})$/,    // fixed, short-form zones (e.g. 02 123 45 67)
        /^32([15678]\d)(\d{2})(\d{2})(\d{2})$/, // fixed, long-form zones (e.g. 012 23 45 67)
        /^32(4\d{2})(\d{2})(\d{2})(\d{2})$/     // mobile (e.g. 0471 23 45 67)
    ];

    return function(input) {
        if (!input) return '';

        for (var i = 0; i < BE_FORMATS.length; i++){
            var format = BE_FORMATS[i];
            var match = format.exec(input);
            if (match)
                return '0'+match[1]+' '+match[2]+' '+match[3]+' '+match[4];
        }

        return input;
    };
}]);
